import _slicedToArray from '../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import { useState } from 'react';

/**
 * Takes in props and creates event handlers that can be passed to a component along with
 * a boolean representing the hover state
 *
 * @param {object} props - The props of the component that will be hovered on to avoid prop override
 * @returns {[boolean, {onMouseEnter: Function, onMouseLeave: Function}]} - A two-element,
 * mixed-type array where the first element is a boolean indicating the element is
 * focused or hovered and the second element is an object containing
 * the event handlers to attach to the element
 */

var useHover = function useHover(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var eventHandlerProps = {
    onMouseEnter: function onMouseEnter(event) {
      if (!isHovering) {
        setIsHovering(true);
      }

      event.stopPropagation();

      if (props.onMouseEnter) {
        props.onMouseEnter(event);
      }
    },
    onMouseLeave: function onMouseLeave(event) {
      if (isHovering) {
        setIsHovering(false);
      }

      if (props.onMouseLeave) {
        props.onMouseLeave(event);
      }
    }
  };
  return [isHovering, eventHandlerProps];
};

export default useHover;
